module.exports = __webpack_public_path__ + "media/kootto.6dd248b1.webm";